import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  individualUnpaidLeavesService,
  StartIndividualUnpaidLeaveRequest,
} from '@aslanpay/portal-common-lib';

const useStartUnpaidLeave = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, StartIndividualUnpaidLeaveRequest>) => {
  return useMutation<unknown, Error, StartIndividualUnpaidLeaveRequest>(
    ({ id }: StartIndividualUnpaidLeaveRequest) =>
      individualUnpaidLeavesService.startIndividualUnpaidLeave({
        id,
      }),
    { onSuccess, onError }
  );
};

export default useStartUnpaidLeave;
